module.exports = __webpack_public_path__ + "img/piano.85ed5ae2.svg";